export default function () {
  this.loadSalesData()
}
